import moment from 'moment';

class Calendar {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-calendar="scope"]',
			input: '[data-calendar="input"]',
			calendar: '[data-calendar="calendar"]',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((index, scope) => {
			let $scope = $(scope);
			let $calendar = $scope.find(this.config.calendar);
			let settings = Object.assign({
				date: new Date(),
				showTodayButton: false,
				weekDayLength: 2,
				prevButton: "<i class='far fa-angle-left'></i>",
				nextButton: "<i class='far fa-angle-right'></i>",
				onClickDate: this.selectDate.bind(this, $scope, $calendar)
			}, $calendar.data());

			$calendar.calendar(settings);
		});
	}

	selectDate($scope, $calendar, date) {
		let $input = $scope.find(this.config.input);
		$input.val(moment(date).format('DD-MM-YYYY'))
		$calendar.updateCalendarOptions({date: date});
	}
}

export default Calendar;